import React from 'react'

import PropTypes from 'prop-types'

import FeedItem from 'Pods/Profile/Dashboard/Feed/Components/FeedItem'

function Feed({ notifications }) {
  return (
    <div className="popover-content no-pad-left-right feed-container">
      {notifications.map((feedItem, index) => (
        <FeedItem
          checked={feedItem.attributes.checked}
          title={feedItem.attributes.bubble}
          body=""
          thumbnail={feedItem.attributes.thumbnail}
          fallbackThumbnail={feedItem.attributes.fallbackThumbnail}
          createdAt={feedItem.attributes.createdAt}
          category={feedItem.attributes.category}
          points={feedItem.attributes.points}
          key={`${feedItem.attributes.thumbnail}-${index}`}
        />
      ))}
      <div className="popover-content__actions">
        <a href="/profile/feed" className="btn btn-transparent btn-block btn-learn-more">
          Show all
        </a>
      </div>
    </div>
  )
}

Feed.propTypes = {
  notifications: PropTypes.array.isRequired,
}

export default Feed
